import { render, staticRenderFns } from "./x-button-group.vue?vue&type=template&id=71618614"
import script from "./x-button-group.vue?vue&type=script&lang=js"
export * from "./x-button-group.vue?vue&type=script&lang=js"
import style0 from "./x-button-group.vue?vue&type=style&index=0&id=71618614&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports